import { UseFormSetValue } from 'react-hook-form';
import { UserBasic } from 'types/user';
import { ReferenceTemplate } from 'types/application';
import { Automation } from 'features/Automations/types';
import { SelectOption, ReferenceCheckFormData } from '../types';

export const createCandidateStatusOptions = (
  applicationStatuses?: Array<{ id?: number; label?: string }>
): SelectOption[] => [
  { value: '', label: 'Select candidate status', disabled: true },
  ...(applicationStatuses?.map((status) => ({
    value: status.id?.toString() || '',
    label: status.label || '',
  })) || []),
];

export const createEmailTemplateOptions = (
  emailTemplates?: Array<{ id: number; title: string }>
): SelectOption[] => [
  { value: '', label: 'Select email template', disabled: true },
  ...(emailTemplates?.map((template) => ({
    value: template.id.toString(),
    label: template.title,
  })) || []),
];

export const createReferenceTemplateOptions = (
  referenceTemplatesData?: ReferenceTemplate[]
): SelectOption[] => [
  { value: '', label: 'Select reference check template', disabled: true },
  ...(referenceTemplatesData?.map((template: ReferenceTemplate) => ({
    value: template.id.toString(),
    label: template.title,
  })) || []),
];

export const createUserOptions = (superAndDistrictAdmins?: UserBasic[]): SelectOption[] => [
  { value: '', label: 'Select user', disabled: true },
  ...(superAndDistrictAdmins?.map((admin: UserBasic) => ({
    value: admin.id.toString(),
    label: admin.name,
  })) || []),
];

export const assignEditableReferenceCheckAutomationProperties = (
  automation: Automation,
  setValue: UseFormSetValue<ReferenceCheckFormData>
): void => {
  if (!automation) return;

  setValue('id', automation.id || null);
  setValue('emailTemplate', automation.email?.email_template_id?.toString() || '');
  setValue('fromUser', automation.email?.sender?.toString() || '');
  setValue('referenceTemplate', automation.action.reference_template_id?.toString() || '');
  setValue('candidateStatus', automation.trigger.new_status_id?.toString() || '');
};
